import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Edit } from '@mui/icons-material';

const TableActionButton = ({ title, icon: Component, onClick, disabled, buttonProps = {} }) => {
  const iconProps = {
    fontSize: 'small',
  };

  return (
    <Tooltip arrow title={title} placement="top">
      <span style={{ display: 'inline-block', cursor: disabled ? 'not-allowed' : 'standard' }}>
        <IconButton
          sx={{ margin: 0.5 }}
          color="primary"
          onClick={onClick}
          disabled={disabled}
          {...buttonProps}
          size="large"
        >
          {Component && (
            <Component {...iconProps} />
          )}

          {!Component && (
            <Edit {...iconProps} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default TableActionButton;
